module.exports = __webpack_public_path__ + "4a9576b34c0775f95524b71a88c3a46f.pdf";